var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4856 3.39307C10.0476 3.14294 9.5405 3 9 3H1.5C0.671573 3 0 3.67157 0 4.5V10C0 11.0532 0.542725 11.9796 1.36376 12.5149L2.09478 11.7839C1.4451 11.4536 1 10.7788 1 10V4.5C1 4.22386 1.22386 4 1.5 4H9C9.26068 4 9.50972 4.04987 9.73808 4.1406L10.4856 3.39307ZM11 7.12132L12.4853 5.63604L14.8 3.9C15.2944 3.52918 16 3.88197 16 4.5V11.5C16 12.118 15.2944 12.4708 14.8 12.1L12 10V11.5C12 12.3284 11.3284 13 10.5 13H5.12132L6.12132 12H10.5C10.7761 12 11 11.7761 11 11.5V9V7.12132ZM15 11L12 8.75V7.25L15 5V11Z",
    fill: "#E02828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.5L0.5 15.5",
    stroke: "#DE2828",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOff);
export default __webpack_public_path__ + "static/media/video-off.12238a4847477e0dadf2537f92da1944.svg";
export { ForwardRef as ReactComponent };